let handler= function(data,options={},before,after){
    let element={}
    console.log(data)
    for(var i=0;i<data.length;i++){
        element=before?before(data[i]):data[i]
        if(element[options.keys]&&element[options.keys].length){
            delete element[options.keys][0].id
           Object.assign(element,element[options.keys][0])
            if(element[options.keys].length<=1){
                delete  element[options.keys]
            }else{
                element[options.keys].splice(0,1)
                element[options.keys].forEach((value,index) => {
                delete value.id
                delete value.created_at
                let obj={}
                Object.keys(element).forEach((v)=> {
                    if(v!=options.keys){
                        obj[v]=''
                    }
                    // if(v.indexOf('sn')==-1){
                    //     obj[v]=''
                    // }else{
                    //     obj[v]=element[v]
                    // }
                });
                data.splice(i+index+1,0,Object.assign({},obj, value))
            });
            }
            }
    }
    return data
       
    // data.forEach((element,key) => {
         
    //       console.log(element[options.keys])
  
    //   })
    //   return data 
  } 
export default handler